export default "__VITE_ASSET__C6PfN8ko__"